import { matchPath } from 'react-router-dom';
/**
 * @returns true if one of the route match pathname
 */
export const matchRoutesPaths = (pathname, routes) => {
    return routes.some(route => Boolean(matchPath(pathname, route)));
};
